// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.touring.SatelliteWebLandlordTouringHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordTouringHandler_getTourForConversationId,
  SatelliteWebLandlordTouringHandler_getTourForConversationId_Path,
  SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing,
  SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Path,
  SatelliteWebLandlordTouringHandler_performTourAction,
  SatelliteWebLandlordTouringHandler_scheduleTour,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordGetTourForConversationIdRequestDto,
  SatelliteWebLandlordGetTourForConversationIdResponseDto,
  SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
  SatelliteWebLandlordGetTouringTreatmentResponseDto,
  SatelliteWebLandlordPerformTourActionRequestDto,
  SatelliteWebLandlordPerformTourActionResponseDto,
  SatelliteWebLandlordScheduleTourRequestDto,
  SatelliteWebLandlordScheduleTourResponseDto,
} from '@zg-rentals/ts-satellite-client';

export type SatelliteWebLandlordTouringHandler_getTourForConversationId_Options = UseQueryOptions<
  SatelliteWebLandlordGetTourForConversationIdResponseDto,
  unknown,
  SatelliteWebLandlordGetTourForConversationIdResponseDto,
  readonly [string, SatelliteWebLandlordGetTourForConversationIdRequestDto]
>;

const SatelliteWebLandlordTouringHandler_getTourForConversationId_GetKey = (
  postData: SatelliteWebLandlordGetTourForConversationIdRequestDto,
) => [SatelliteWebLandlordTouringHandler_getTourForConversationId_Path, postData] as const;

export const SatelliteWebLandlordTouringHandler_getTourForConversationId_queryOptions = (
  postData: SatelliteWebLandlordGetTourForConversationIdRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordTouringHandler_getTourForConversationId_GetKey(postData),
    queryFn: () => SatelliteWebLandlordTouringHandler_getTourForConversationId(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get tour for satellite conversation id via z-calendar service
 */
export const useSatelliteWebLandlordTouringHandler_getTourForConversationId = (
  postData: SatelliteWebLandlordGetTourForConversationIdRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordTouringHandler_getTourForConversationId_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordTouringHandler_getTourForConversationId_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordTouringHandler_getTourForConversationId.getKey =
  SatelliteWebLandlordTouringHandler_getTourForConversationId_GetKey;

export type SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Options = UseQueryOptions<
  SatelliteWebLandlordGetTouringTreatmentResponseDto,
  unknown,
  SatelliteWebLandlordGetTouringTreatmentResponseDto,
  readonly [string, SatelliteWebLandlordGetTouringTreatmentForListingRequestDto]
>;

const SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_GetKey = (
  postData: SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
) => [SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Path, postData] as const;

export const SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_queryOptions = (
  postData: SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_GetKey(postData),
    queryFn: () => SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get touring treatment for listing via z-calendar service
 */
export const useSatelliteWebLandlordTouringHandler_getTouringTreatmentForListing = (
  postData: SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordTouringHandler_getTouringTreatmentForListing.getKey =
  SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_GetKey;

export interface SatelliteWebLandlordTouringHandler_performTourAction_Args {
  postData: SatelliteWebLandlordPerformTourActionRequestDto;
}

export type SatelliteWebLandlordTouringHandler_performTourAction_Options = UseMutationOptions<
  SatelliteWebLandlordPerformTourActionResponseDto,
  unknown,
  SatelliteWebLandlordTouringHandler_performTourAction_Args
>;

/**
 * Perform a tour action as a landlord via z-calendar service
 */
export const useSatelliteWebLandlordTouringHandler_performTourAction = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordTouringHandler_performTourAction_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordTouringHandler_performTourAction_Args) =>
      SatelliteWebLandlordTouringHandler_performTourAction(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordTouringHandler_scheduleTour_Args {
  postData: SatelliteWebLandlordScheduleTourRequestDto;
}

export type SatelliteWebLandlordTouringHandler_scheduleTour_Options = UseMutationOptions<
  SatelliteWebLandlordScheduleTourResponseDto,
  unknown,
  SatelliteWebLandlordTouringHandler_scheduleTour_Args
>;

/**
 * Add a tour the landlord negotiated with the renter
 */
export const useSatelliteWebLandlordTouringHandler_scheduleTour = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordTouringHandler_scheduleTour_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordTouringHandler_scheduleTour_Args) =>
      SatelliteWebLandlordTouringHandler_scheduleTour(args.postData, httpClient),
  });
};
